exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tab-new-old-box {\n  text-align: right;\n  \n  padding: 0 20px;\n  color: #c59d01;\n  margin: 20px 0;\n}\n.tab-new-old-box a {\n  color: #c59d01;\n  text-transform: capitalize;\n  border-bottom: 1px solid #c59d01;\nfont-size: 15px;\n}\n.newest-box {\n  margin: 0 12px 0 0;\n}\n.tab-new-old-box a i {\n  margin: 0 3px 0 0;\n}\n.tab-new-old-box a:hover, .tab-new-old-box a.active {\n  text-decoration: none;\n  color: #c0233a;\n  border-bottom: 1px solid #bf2239;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/projects/wct-nextias-ui/src/app/home/jobannouncementlist/jobannouncementlist.component.css
// module id = ../../../../../src/app/home/jobannouncementlist/jobannouncementlist.component.css
// module chunks = common